module.exports = __webpack_public_path__ + "static/img/modal-question.57744639.png";